"use client";
function r(s, o) {
  const e = ["API", "Docs", "Documentation", "Blogs", o], n = ["\\|", "-", ":"], t = new RegExp(
    `^\\s*(${e.join("|")})(\\.\\w+)?\\s*(${n.join("|")})\\s*`,
    "gi"
  ), i = new RegExp(
    `\\s*(${n.join("|")})\\s*(${e.join("|")})\\s*$`,
    "gi"
  );
  return s.replace(t, "").replace(i, "").trim();
}
export {
  r as stripBrandingKeywords
};
